export const parseFiltersToQueryString = (filters = {}) => {
    const params = new URLSearchParams();

    const operatorMap = {
        eq: "[eq]",
        ne: "[ne]",
        like: "[like]",
        gt: "[gt]",
        gte: "[gte]",
        lt: "[lt]",
        lte: "[lte]",
        in: "[in]",
        notin: "[notin]",
        null: "[null]",
        notnull: "[not]"
    };

    Object.entries(filters).forEach(([key, filter]) => {
        if (!filter.value || filter.value.length === 0) return;

        const queryOperator = operatorMap[filter.operator] || operatorMap.eq;

        if (Array.isArray(filter.value)) {
            params.append(`${key}${queryOperator}`, filter.value.join(","));
        } else {
            params.append(`${key}${queryOperator}`, filter.value);
        }
    });

    return params.toString();
};
